const INITIAL_STATE = {
  way: null,
};


const digitalWayReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;

  const reducer = {
      SET_DIGITAL_WAY: () => ({ ...state, way: action.way })
  }

  return reducer[type] ? reducer[type]() : { ...state};
}

export default digitalWayReducer;
